/* =========================================================================
    CUSTOM SIZE ESTIMATOR FORM AUTO-SYNC
 ========================================================================= */
(function () {
    let customSizeRecordId = null;
    let customSizeDebounceTimer = null;
    let isCustomSizeCreating = false;
    let customSizeCreationPromise = null;
    let customSizeSessionId = 0;

    function resetCustomSizeSyncState() {
        customSizeSessionId++;
        clearTimeout(customSizeDebounceTimer);
        customSizeDebounceTimer = null;
        customSizeRecordId = null;
        isCustomSizeCreating = false;
        customSizeCreationPromise = null;
        // A price calculated for a previous preset/dimension pair is no
        // longer valid for a brand-new session — must not bleed into the
        // next open's payload.
        window.lastCalculatedFinalPrice = null;
    }
    window.resetCustomSizeSyncState = resetCustomSizeSyncState;

    // Called whenever the currently staged price is invalidated (e.g. the
    // user edits width/height after picking a preset, or after a price was
    // already calculated) so a stale price doesn't get sent alongside the
    // new, not-yet-priced dimensions.
    function clearCustomSizeFinalPrice() {
        window.lastCalculatedFinalPrice = null;
    }
    window.clearCustomSizeFinalPrice = clearCustomSizeFinalPrice;

    function getStoredLocation() {
        try {
            return localStorage.getItem('location') || '';
        } catch (e) {
            return '';
        }
    }

    // Function to gather input values from the Custom Size Estimator Form
    function getCustomSizeFormData() {
        const activeTab = document.querySelector('.smz-type-tab.active, .smz-sign-type-active');
        let signTypeVal = (typeof SMZ !== 'undefined' && SMZ.type) ? SMZ.type : '';
        if (!signTypeVal && activeTab) {
            signTypeVal = activeTab.getAttribute('data-type') || activeTab.value || activeTab.textContent;
        }
        if (typeof smzGetApiSignType === 'function' && signTypeVal) {
            signTypeVal = smzGetApiSignType(signTypeVal) || signTypeVal;
        }

        const staged = (typeof SMZ !== 'undefined' && SMZ.staged) ? SMZ.staged : null;

        const wEl = document.getElementById('smzWidth') || document.querySelector('#width-in, input[name="width_in"], input[name="width"]');
        const hEl = document.getElementById('smzHeight') || document.querySelector('#height-in, input[name="height_in"], input[name="height"]');
        // A staged preset blanks the raw width/height inputs (its dimensions
        // live on SMZ.staged instead), so it must be checked before falling
        // back to SMZ.width/height, which only track manually typed values.
        const widthVal = (wEl && wEl.value) ? parseFloat(wEl.value)
            : (staged && staged.width != null) ? staged.width
                : ((typeof SMZ !== 'undefined' && SMZ.width) ? SMZ.width : null);
        const heightVal = (hEl && hEl.value) ? parseFloat(hEl.value)
            : (staged && staged.height != null) ? staged.height
                : ((typeof SMZ !== 'undefined' && SMZ.height) ? SMZ.height : null);

        const stagedPrice = (staged && staged.price) ? staged.price : null;
        // Scoped to the modal only — an unscoped lookup could otherwise match
        // an unrelated same-ID/class price element elsewhere on the page.
        const modalRoot = document.getElementById('smzOverlay') || document;
        const finalPriceElement = modalRoot.querySelector('#smzLivePrice, #smzPriceValue, #final-price, .smz-final-price, [data-final-price]');
        // Prefer the currently staged/displayed price over the last-calculated
        // global — that global is only a fallback for async completion races
        // and must not outlive the selection it was calculated for (callers
        // clear it via clearCustomSizeFinalPrice() whenever the staged price
        // is invalidated, e.g. the user edits dimensions after a preset pick).
        const finalPriceVal = stagedPrice
            || (finalPriceElement ? finalPriceElement.textContent || finalPriceElement.value : null)
            || window.lastCalculatedFinalPrice;

        return {
            type_of_sign: signTypeVal ? String(signTypeVal).trim() : '',
            width_in: widthVal ? parseFloat(widthVal) : null,
            height_in: heightVal ? parseFloat(heightVal) : null,
            final: finalPriceVal ? parseFloat(String(finalPriceVal).replace(/[^0-9.]/g, '')) : null,
            payment_url: window.location.href,
            location: getStoredLocation(),
            project: 'Signage.inc'
        };
    }

    // Function to sync data to backend (Create or Update)
    async function syncCustomSizeData() {
        if (isCustomSizeCreating && customSizeCreationPromise) {
            try {
                await customSizeCreationPromise;
            } catch (e) {
                // Ignore initial creation error, will retry or update
            }
        }

        // Called after add-size-variant successfully completes — flags the
        // Airtable record with sent_to_at so the backend can branch on its presence.
        window.markCustomSizeSentToAt = function () {
            const recordId = customSizeRecordId;
            if (!recordId) return;

            try {
                fetch('https://webhooks.codeblue.agency/api/custom-size/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    keepalive: true,
                    body: JSON.stringify({
                        record_id: recordId,
                        sent_to_at: true,
                        location: getStoredLocation(),
                        project: 'Signage.inc'
                    })
                }).then(function (response) {
                    return response.json().catch(function () { return null; });
                }).then(function (result) {
                    console.log('[Custom Size Sync] Marked sent_to_at for Airtable Record ID:', recordId, result);
                }).catch(function (err) {
                    console.error('[Custom Size Sync sent_to_at Exception]:', err);
                });
            } catch (err) {
                console.error('[Custom Size Sync sent_to_at Exception]:', err);
            }
        };

        const data = getCustomSizeFormData();

        // Do not sync if minimal dimension or sign type data is absent
        if (!data.type_of_sign && !data.width_in && !data.height_in) {
            return;
        }

        const doFetch = async () => {
            const thisSession = customSizeSessionId;
            const isUpdate = Boolean(customSizeRecordId);
            const endpoint = isUpdate
                ? 'https://webhooks.codeblue.agency/api/custom-size/update'
                : 'https://webhooks.codeblue.agency/api/custom-size/create';

            const payload = {
                ...data,
                project: 'Signage.inc'
            };
            if (isUpdate && customSizeRecordId) {
                payload.record_id = customSizeRecordId;
            }

            try {
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (response.ok && result.success) {
                    if (thisSession === customSizeSessionId) {
                        if (!customSizeRecordId && result.record_id) {
                            customSizeRecordId = result.record_id;
                            console.log('[Custom Size Sync] Created Airtable Record ID:', customSizeRecordId);
                        } else {
                            console.log('[Custom Size Sync] Updated Airtable Record ID:', customSizeRecordId);
                        }
                    }
                    return result;
                } else {
                    console.error('[Custom Size Sync Error]:', result);
                }
            } catch (err) {
                console.error('[Custom Size Sync Exception]:', err);
            }
        };

        const initialRecordId = customSizeRecordId;
        if (!initialRecordId && !isCustomSizeCreating) {
            isCustomSizeCreating = true;
            customSizeCreationPromise = doFetch().finally(() => {
                isCustomSizeCreating = false;
                customSizeCreationPromise = null;
            });
            return customSizeCreationPromise;
        } else {
            return doFetch();
        }
    }

    // Debounced listener (Fast 500ms initial creation, 2-second update debounce)
    function handleCustomSizeInput() {
        clearTimeout(customSizeDebounceTimer);
        const delay = customSizeRecordId ? 2000 : 500;
        customSizeDebounceTimer = setTimeout(() => {
            syncCustomSizeData();
        }, delay);
    }

    // Global Event Delegation for Custom Size Estimator Form inputs
    document.addEventListener('input', (e) => {
        if (e.target && (e.target.id === 'smzWidth' || e.target.id === 'smzHeight' || e.target.closest('#smzModal, #smzOverlay, .smz-card'))) {
            handleCustomSizeInput();
        }
    });

    document.addEventListener('change', (e) => {
        if (e.target && (e.target.id === 'smzWidth' || e.target.id === 'smzHeight' || e.target.closest('#smzModal, #smzOverlay, .smz-card'))) {
            handleCustomSizeInput();
        }
    });

    document.addEventListener('click', (e) => {
        if (e.target && (e.target.closest('.smz-type-tab, .smz-preset, #smzGetPrice, #smzPresetGrid'))) {
            handleCustomSizeInput();
        }
    });

    // Global helper if price API calculation finishes asynchronously:
    window.triggerCustomSizeAutoSync = function (finalPrice) {
        if (finalPrice) {
            window.lastCalculatedFinalPrice = finalPrice;
        }
        handleCustomSizeInput();
    };

    // Final "complete" signal — fired on modal close. Cancels any pending
    // debounce and, if a record exists for this session, flags it as
    // closed/finalized so Airtable doesn't show it as silently abandoned.
    async function completeCustomSizeSync() {
        clearTimeout(customSizeDebounceTimer);
        customSizeDebounceTimer = null;

        const recordIdToComplete = customSizeRecordId;
        if (recordIdToComplete) {
            try {
                await fetch('https://webhooks.codeblue.agency/api/custom-size/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        record_id: recordIdToComplete,
                        project: 'Signage.inc',
                        location: getStoredLocation(),
                        status: 'Completed'
                    })
                });
                console.log('[Custom Size Sync] Finalized Airtable Record ID:', recordIdToComplete);
            } catch (err) {
                console.error('[Custom Size Sync] Complete signal failed:', err);
            }
        }

        resetCustomSizeSyncState();
    }
    window.completeCustomSizeSync = completeCustomSizeSync;
})();